// WARNING: This file was auto generated by the code in web-rnd/tygen.
// Do not commit manual changes to this file.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import packageInfo from "../package.json";
export const dtoExportFormatNames = ["glb", "gltf", "fbx", "dwg", "cmdrw", "cmfav", "cmsym"];
export const dtoExportStatusStatusNames = ["pending", "running", "finished", "failed"];
export const dtoNoteSeverityNames = ["Information", "Critical", "Warning"];
export const dtoRenderFormatNames = ["jpg", "png"];
export const dtoRenderStatusStatusNames = ["pending", "running", "finished", "failed"];
export const dtoSyncGroupMethodsNames = ["pull", "push", "twoWay"];
export class DtoAPIError extends Error {
}
export class CatalogueAPI {
    constructor(_fetch = window.fetch.bind(window)) {
        this._fetch = _fetch;
    }
    // For internal use
    _saveAlternativeReferer() {
        if (typeof document === "undefined") {
            return;
        }
        const parts = new RegExp("^(http[s]?:\\/\\/[^:\\/\\s]+)", "i").exec(document.referrer);
        if (parts !== null) {
            this._alternativeReferer = parts[1];
        }
    }
    hasFeature(feature) {
        return this.auth !== undefined && this.auth.apiSession.features !== undefined && this.auth.apiSession.features.indexOf(feature) > -1;
    }
    fetch(url, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let response;
            let body;
            let err;
            if (options.method === "POST" && options.body) {
                options.headers["Content-Type"] = "application/json;charset=utf-8";
            }
            try {
                response = yield this._fetch(url, options);
                body = yield response.text();
                const parsed = JSON.parse(body);
                if (parsed && typeof parsed === "object" && "error" in parsed) {
                    err = new DtoAPIError(parsed.error);
                    err.body = body;
                    err.status = response.status;
                    err.parsed = parsed;
                }
                else {
                    return parsed;
                }
            }
            catch (e) {
                const msg = e instanceof Error ? e.message : `${e}`;
                err = new DtoAPIError(msg);
                err.body = body;
                err.status = response && response.status;
                err.error = e instanceof Error ? e : Error(msg);
            }
            throw err;
        });
    }
    postPublicAccessTokenAuthorize(params, endpoint) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/access-token/public/${encodeURIComponent(params.accessTokenId)}/authorize`;
            const options = {
                method: "POST",
                headers: { "X-SDK-Version": packageInfo.version },
            };
            if (this._alternativeReferer) {
                options.headers["Alternative-Referer"] = this._alternativeReferer;
            }
            return this.fetch(endpoint + url, options);
        });
    }
    getApplicationAreas(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.auth === undefined) {
                throw new Error("missing auth");
            }
            const url = `/v1/catalogue/${encodeURIComponent(params.lang)}/${encodeURIComponent(params.enterprise)}/${encodeURIComponent(params.prdCat)}/${encodeURIComponent(params.prdCatVersion)}/${encodeURIComponent(params.vendor)}/${encodeURIComponent(params.priceList)}/application-areas`;
            const options = {
                method: "GET",
                headers: { "X-API-Key": this.auth.secretToken || "", "X-SDK-Version": packageInfo.version },
            };
            if (this._alternativeReferer) {
                options.headers["Alternative-Referer"] = this._alternativeReferer;
            }
            return this.fetch(this.auth.endpoint + url, options);
        });
    }
    postExport(params, body) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.auth === undefined) {
                throw new Error("missing auth");
            }
            const url = `/v1/catalogue/${encodeURIComponent(params.lang)}/${encodeURIComponent(params.enterprise)}/${encodeURIComponent(params.prdCat)}/${encodeURIComponent(params.prdCatVersion)}/${encodeURIComponent(params.vendor)}/${encodeURIComponent(params.priceList)}/export/${encodeURIComponent(params.partNumber)}`;
            const options = {
                method: "POST",
                headers: { "X-API-Key": this.auth.secretToken || "", "X-SDK-Version": packageInfo.version },
                body: JSON.stringify(body),
            };
            if (this._alternativeReferer) {
                options.headers["Alternative-Referer"] = this._alternativeReferer;
            }
            return this.fetch(this.auth.endpoint + url, options);
        });
    }
    getPriceLists(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.auth === undefined) {
                throw new Error("missing auth");
            }
            const url = `/v1/catalogue/${encodeURIComponent(params.lang)}/${encodeURIComponent(params.enterprise)}/${encodeURIComponent(params.prdCat)}/${encodeURIComponent(params.prdCatVersion)}/${encodeURIComponent(params.vendor)}/${encodeURIComponent(params.priceList)}/price-lists`;
            const options = {
                method: "GET",
                headers: { "X-API-Key": this.auth.secretToken || "", "X-SDK-Version": packageInfo.version },
            };
            if (this._alternativeReferer) {
                options.headers["Alternative-Referer"] = this._alternativeReferer;
            }
            return this.fetch(this.auth.endpoint + url, options);
        });
    }
    getProductLegacyV2(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.auth === undefined) {
                throw new Error("missing auth");
            }
            const url = `/v1/catalogue/${encodeURIComponent(params.lang)}/${encodeURIComponent(params.enterprise)}/${encodeURIComponent(params.prdCat)}/${encodeURIComponent(params.prdCatVersion)}/${encodeURIComponent(params.vendor)}/${encodeURIComponent(params.priceList)}/product-v2/${encodeURIComponent(params.partNumber)}`;
            const options = {
                method: "GET",
                headers: { "X-API-Key": this.auth.secretToken || "", "X-SDK-Version": packageInfo.version },
            };
            if (this._alternativeReferer) {
                options.headers["Alternative-Referer"] = this._alternativeReferer;
            }
            return this.fetch(this.auth.endpoint + url, options);
        });
    }
    getProduct(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.auth === undefined) {
                throw new Error("missing auth");
            }
            const url = `/v1/catalogue/${encodeURIComponent(params.lang)}/${encodeURIComponent(params.enterprise)}/${encodeURIComponent(params.prdCat)}/${encodeURIComponent(params.prdCatVersion)}/${encodeURIComponent(params.vendor)}/${encodeURIComponent(params.priceList)}/product-v3/${encodeURIComponent(params.partNumber)}`;
            const options = {
                method: "GET",
                headers: { "X-API-Key": this.auth.secretToken || "", "X-SDK-Version": packageInfo.version },
            };
            if (this._alternativeReferer) {
                options.headers["Alternative-Referer"] = this._alternativeReferer;
            }
            return this.fetch(this.auth.endpoint + url, options);
        });
    }
    postRender(params, body) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.auth === undefined) {
                throw new Error("missing auth");
            }
            const url = `/v1/catalogue/${encodeURIComponent(params.lang)}/${encodeURIComponent(params.enterprise)}/${encodeURIComponent(params.prdCat)}/${encodeURIComponent(params.prdCatVersion)}/${encodeURIComponent(params.vendor)}/${encodeURIComponent(params.priceList)}/product/${encodeURIComponent(params.partNumber)}/render`;
            const options = {
                method: "POST",
                headers: { "X-API-Key": this.auth.secretToken || "", "X-SDK-Version": packageInfo.version },
                body: JSON.stringify(body),
            };
            if (this._alternativeReferer) {
                options.headers["Alternative-Referer"] = this._alternativeReferer;
            }
            return this.fetch(this.auth.endpoint + url, options);
        });
    }
    postValidateLegacyV1(params, body) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.auth === undefined) {
                throw new Error("missing auth");
            }
            const url = `/v1/catalogue/${encodeURIComponent(params.lang)}/${encodeURIComponent(params.enterprise)}/${encodeURIComponent(params.prdCat)}/${encodeURIComponent(params.prdCatVersion)}/${encodeURIComponent(params.vendor)}/${encodeURIComponent(params.priceList)}/product/${encodeURIComponent(params.partNumber)}/validate`;
            const options = {
                method: "POST",
                headers: { "X-API-Key": this.auth.secretToken || "", "X-SDK-Version": packageInfo.version },
                body: JSON.stringify(body),
            };
            if (this._alternativeReferer) {
                options.headers["Alternative-Referer"] = this._alternativeReferer;
            }
            return this.fetch(this.auth.endpoint + url, options);
        });
    }
    postValidate(params, body) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.auth === undefined) {
                throw new Error("missing auth");
            }
            const url = `/v1/catalogue/${encodeURIComponent(params.lang)}/${encodeURIComponent(params.enterprise)}/${encodeURIComponent(params.prdCat)}/${encodeURIComponent(params.prdCatVersion)}/${encodeURIComponent(params.vendor)}/${encodeURIComponent(params.priceList)}/product/${encodeURIComponent(params.partNumber)}/validate-v2`;
            const options = {
                method: "POST",
                headers: { "X-API-Key": this.auth.secretToken || "", "X-SDK-Version": packageInfo.version },
                body: JSON.stringify(body),
            };
            if (this._alternativeReferer) {
                options.headers["Alternative-Referer"] = this._alternativeReferer;
            }
            return this.fetch(this.auth.endpoint + url, options);
        });
    }
    getTocTree(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.auth === undefined) {
                throw new Error("missing auth");
            }
            const url = `/v1/catalogue/${encodeURIComponent(params.lang)}/${encodeURIComponent(params.enterprise)}/${encodeURIComponent(params.prdCat)}/${encodeURIComponent(params.prdCatVersion)}/${encodeURIComponent(params.vendor)}/${encodeURIComponent(params.priceList)}/toc`;
            const options = {
                method: "GET",
                headers: { "X-API-Key": this.auth.secretToken || "", "X-SDK-Version": packageInfo.version },
            };
            if (this._alternativeReferer) {
                options.headers["Alternative-Referer"] = this._alternativeReferer;
            }
            return this.fetch(this.auth.endpoint + url, options);
        });
    }
    getTocFlat(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.auth === undefined) {
                throw new Error("missing auth");
            }
            const url = `/v1/catalogue/${encodeURIComponent(params.lang)}/${encodeURIComponent(params.enterprise)}/${encodeURIComponent(params.prdCat)}/${encodeURIComponent(params.prdCatVersion)}/${encodeURIComponent(params.vendor)}/${encodeURIComponent(params.priceList)}/toc/flat`;
            const options = {
                method: "GET",
                headers: { "X-API-Key": this.auth.secretToken || "", "X-SDK-Version": packageInfo.version },
            };
            if (this._alternativeReferer) {
                options.headers["Alternative-Referer"] = this._alternativeReferer;
            }
            return this.fetch(this.auth.endpoint + url, options);
        });
    }
    getExportById(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.auth === undefined) {
                throw new Error("missing auth");
            }
            const url = `/v1/export/${encodeURIComponent(params.uuid)}`;
            const options = {
                method: "GET",
                headers: { "X-API-Key": this.auth.secretToken || "", "X-SDK-Version": packageInfo.version },
            };
            if (this._alternativeReferer) {
                options.headers["Alternative-Referer"] = this._alternativeReferer;
            }
            return this.fetch(this.auth.endpoint + url, options);
        });
    }
    getRenderById(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.auth === undefined) {
                throw new Error("missing auth");
            }
            const url = `/v1/render/${encodeURIComponent(params.uuid)}`;
            const options = {
                method: "GET",
                headers: { "X-API-Key": this.auth.secretToken || "", "X-SDK-Version": packageInfo.version },
            };
            if (this._alternativeReferer) {
                options.headers["Alternative-Referer"] = this._alternativeReferer;
            }
            return this.fetch(this.auth.endpoint + url, options);
        });
    }
    postSessionTokenRefresh() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.auth === undefined) {
                throw new Error("missing auth");
            }
            const url = `/v1/session-token/refresh`;
            const options = {
                method: "POST",
                headers: { "X-API-Key": this.auth.secretToken || "", "X-SDK-Version": packageInfo.version },
            };
            if (this._alternativeReferer) {
                options.headers["Alternative-Referer"] = this._alternativeReferer;
            }
            return this.fetch(this.auth.endpoint + url, options);
        });
    }
}
export const DTO_OPERATION_ID_TO_DEBIT_GROUP = {
    postPublicAccessTokenAuthorize: "base",
    getApplicationAreas: "base",
    postExport: "export",
    getPriceLists: "base",
    getProductLegacyV2: "base",
    getProduct: "base",
    postRender: "render",
    postValidateLegacyV1: "base",
    postValidate: "base",
    getTocTree: "base",
    getTocFlat: "base",
    getExportById: "base",
    getRenderById: "base",
};
